import { UiState } from 'src/react/common/state/UiState';

export const UI_DEFAULT_STATE: UiState = {
    openModals: [],
    openPopovers: [],
    hasRouteLoader: false,
    clientHeight: document.documentElement.clientHeight,
};
